import { render, staticRenderFns } from "./propertyNoticeDetail.vue?vue&type=template&id=71af5337&scoped=true"
import script from "./propertyNoticeDetail.vue?vue&type=script&lang=js"
export * from "./propertyNoticeDetail.vue?vue&type=script&lang=js"
import style0 from "./propertyNoticeDetail.vue?vue&type=style&index=0&id=71af5337&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71af5337",
  null
  
)

export default component.exports